import { useQuery } from '@tanstack/react-query';
import { getServiceSheetById } from '../../notifications/service';

function useViewOnlineServiceReport(serviceSheetId: number) {
    return useQuery({
        queryKey: ['service-sheet', serviceSheetId],
        queryFn: async () => {
            const serviceSheet = await getServiceSheetById(serviceSheetId);
            window.location.replace(serviceSheet.serviceReportLink);
            return serviceSheet;
        },
        retry: false,
    });
}

export { useViewOnlineServiceReport };
